import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/numberplateInquiry",
  component: function component() {
    return import("../../../views/store-oil-station/numberplateInquiry.vue");
  },
  name: "numberplateInquiry",
  meta: {
    title: "车牌查询",
    foot: true
  }
}, {
  path: "/InquiryResults/:card_num?",
  component: function component() {
    return import("../../../views/store-oil-station/InquiryResults.vue");
  },
  name: "InquiryResults",
  meta: {
    title: "车牌查询",
    foot: true
  }
}, {
  path: "/oilOrder/:status?/:orderType?",
  component: function component() {
    return import("../../../views/store-oil-station/oilOrder.vue");
  },
  name: "oilOrder",
  meta: {
    title: "加油订单",
    foot: true
  }
}, {
  path: "/qywxCode/:store_id",
  component: function component() {
    return import("../../../views/store-oil-station/qywxCode.vue");
  },
  name: "qywxCode",
  meta: {
    title: "企微码",
    foot: true
  }
}, {
  path: "/refueling_payment/:store_id?",
  component: function component() {
    return import("../../../views/store-oil-station/refueling_payment.vue");
  },
  name: "refueling_payment",
  meta: {
    title: "闪付",
    foot: true
  }
}, {
  path: "/refueling_list/:store_id?",
  component: function component() {
    return import("../../../views/store-oil-station/refueling_list.vue");
  },
  name: "refueling_list",
  meta: {
    title: "油站导航",
    foot: true
  }
}];